import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import ServiceApi from "../../services/ServiceApi";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";

const ForGotPassWord = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [form] = Form.useForm();

  const handleSubmit = (value) => {
    setErrorMessage("");
    setIsLoading(true);
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}PwGetOtp`,
      method: "POST",
      data: {
        OTP: value.otp,
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          notification.success({
            message: "Success",
            description: "Reset your password success",
          });
          form.resetFields();
        } else {
          setErrorMessage(res.result.showText);
        }
        setIsLoading(false);
        console.log("res", res);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setIsLoading(false);
      });
  };
  const handleGetOTP = () => {
    // console.log("form.value", form.getFieldValue());
    const { email } = form.getFieldValue();
    setErrorMessage("");
    setIsLoadingOTP(true);
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}GetOtp`,
      method: "POST",
      data: {
        Email: email,
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          notification.info({
            message: "Send OTP",
            description: "Send to your email",
          });
        } else {
          setErrorMessage(res.result.showText);
        }
        setIsLoadingOTP(false);
        console.log("res", res);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setIsLoadingOTP(false);
      });
  };
  return (
    <div className="container body-content bbtec-theme">
      <div className="background-100"></div>

      <div className="box-container">
        <div>
          <select defaultValue="EN" className="form-control chang-lgg">
            <option value="EN">EN</option>
            <option value="TH">TH</option>
          </select>
        </div>
        <div className="row">
          <div className="col-6 offset-md-1 mt-form-log">
            <div>
              <img src={ServiceApi.absoluteUrl("/img/Group_278.png")} alt="" />
            </div>
            <div
              className="font-mont"
              // id="tabs-forgetpwd"

              style={{ fontSize: 30, color: "#5C72F7", marginTop: 10 }}
            >
              Forgot Your Password
            </div>
            <div
              className="font-mont"
              style={{ fontSize: 12, color: "#999999", marginTop: 5 }}
            >
              Instructions for changing your password
            </div>
            <div
              className="font-mont"
              style={{ fontSize: 9, color: "#999999", marginTop: 5 }}
            >
              1. Enter your email and click "Get OTP", OTP code will be sent to
              your email.
            </div>
            <div
              className="font-mont"
              style={{ fontSize: 9, color: "#999999", marginTop: 5 }}
            >
              2. Enter OTP code (received via email) and click "Get Password",
              new password
            </div>
            <div className="row" style={{ margin: "0px -15px", marginTop: 10 }}>
              <div className="col-8">
                <Form
                  onFinish={handleSubmit}
                  form={form}
                  layout="vertical"
                  hideRequiredMark="true"
                >
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          {
                            required: true,
                            message: "Email is required",
                          },
                        ]}
                        className="for-got-password"
                      >
                        <Input
                          addonAfter={
                            <Button
                              style={{
                                height: 43,
                                backgroundColor: "#5c72f7",
                                color: "#fff",
                              }}
                              onClick={handleGetOTP}
                            >
                              {isLoadingOTP ? <LoadingOutlined /> : "Get OTP"}
                            </Button>
                          }
                          className="get-otp font-mont-r"
                          type="text"
                          size="large"
                          placeholder="Please enter your E-mail"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="otp"
                        label="OTP"
                        rules={[
                          {
                            required: true,
                            message: "OTP is required",
                          },
                        ]}
                        className="for-got-password"
                      >
                        <Input
                          size="large"
                          placeholder="Please enter your OTP"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row justify-content-md-center">
                    <div className="col-auto">
                      <p style={{ color: "#ff0028d1" }}>{errorMessage}</p>
                    </div>
                  </div>
                  <div className="row justify-content-md-center">
                    <div className="col-auto">
                      <Form.Item>
                        <Button
                          loading={isLoading}
                          size="small"
                          className="btn-warning"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 30px",
                          }}
                          onClick={() => form.submit()}
                        >
                          Get Password
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </Form>

                <div className="row">
                  <div
                    className="f-mon alarm-login"
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginTop: "10px",
                      padding: "15px",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-5" style={{ paddingRight: "0px" }}>
            <div className="d-flex flex-row-reverse" align="right">
              <div
                className="fogot-image"
                style={{ marginBottom: "-1px" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForGotPassWord;
